export default {
  callingAPI: false,
  searching: '',
  serverURI: 'http://10.110.1.136:8080',
  user: null,
  token: null,
  userInfo: {
    messages: [],
    notifications: [{1: 'test', 2: 'test'}],
    tasks: []
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js